<div [class]="'ap-pager'">
  <div [class.ap-pagerCell]="true"
       [class.ap-pagerCell-left]="true">
    <div *ngIf="selectedKeys.length">
      {{selectedKeys && selectedKeys.length}} {{'Global__Selected' | translate}}
    </div>
  </div>
  <div *ngIf="itemCount / pageSize > 1"
       [class.ap-pagerCell]="true"
       [class.ap-pagerCell-center]="true">
    <a href="#"
       [style.height]="'30px'"
       [tabindex]="-1"
       [class]="'k-link k-pager-nav k-pager-first'"
       [class.k-state-disabled]="currentPage <= 1"
       (click)="changePage(1)">
      <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltToLeftIcon')"></kendo-svg-icon>
    </a>
    <a href="#"
       [style.height]="'30px'"
       [tabindex]="-1"
       [class]="'k-link k-pager-nav'"
       [class.k-state-disabled]="currentPage <= 1"
       (click)="changePage(currentPage - 1)">
      <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltLeftIcon')"></kendo-svg-icon>
    </a>
    <ap-grid-pager-numeric [pagerContextService]="contextService"></ap-grid-pager-numeric>
    <a href="#" [tabindex]="-1"
       [style.height]="'30px'"
       [class]="'k-link k-pager-nav'"
       [class.k-state-disabled]="currentPage >= numOfPages"
       (click)="changePage(currentPage + 1)">
      <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltRightIcon')"></kendo-svg-icon>
    </a>
    <a href="#" [tabindex]="-1"
       [style.height]="'30px'"
       [class]="'k-link k-pager-nav k-pager-last'"
       [class.k-state-disabled]="currentPage >= numOfPages"
       (click)="changePage(numOfPages)">
      <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltToRightIcon')"></kendo-svg-icon>
    </a>
  </div>
  <div [class.ap-pagerCell]="true"
       [class.ap-pagerCell-right]="true">
    <ap-grid-page-size (pageSizeChanged)="onPageSizeChanged($event)"></ap-grid-page-size>
    <div [class]="'k-pager-info k-label'">
      {{((currentPage - 1) * pageSize) + 1}}
      -
      {{(currentPage * pageSize > itemCount ? itemCount : currentPage * pageSize)}}
      {{'kendo.grid.pagerOf' | translate}}
      {{itemCount}}
      {{'kendo.grid.pagerItems' | translate}}
    </div>
  </div>
</div>
<div class="ap-pager-bottom">
  <div [class.float-left]="selectedKeys.length && iconButtons">
    <ap-grid-multi-select #gridMultiSelectComponent
                          *ngIf="hasMultiSelect"
                          [(selectedValue)]="selectedValue"
                          [(selectedColumn)]="selectedColumn"
                          (selectedColumnChange)="onSelectedColumnChange($event)"
                          (selectedValueChange)="onSelectedValueChange($event)"
                          [columnItemDisabled]="columnItemDisabled"
                          [valueItemDisabled]="valueItemDisabled"
                          [showDefaultValue]="showDefaultValue"
                          [type]="type"
                          [values]="values"
                          [objects]="objects"
                          [preselect]="preselect"
                          [showOnlyValues]="showOnlyValues"
                          [showWithoutSelection]="showWithoutSelection"
                          [selectedKeys]="selectedKeys"
                          [formConfig]="formConfig"
                          [formValidators]="formValidators"
                          [formDefaultValue]="formDefaultValue"
                          (formValueChanges)="formValueChanges.emit($event)"
                          (applyClicked)="applyClicked.emit($event)"
                          (deleteClicked)="deleteClicked.emit($event)"
                          (startInAnimation)="startMultiSelectInAnimation.emit($event)"
                          (endInAnimation)="endMultiSelectInAnimation.emit($event)"
                          (startOutAnimation)="startMultiSelectOutAnimation.emit($event)"
                          (endOutAnimation)="endMultiSelectOutAnimation.emit($event)"
    ></ap-grid-multi-select>
  </div>
  <div *ngIf="selectedKeys.length && iconButtons" [class]="'float-right'">
    <kendo-buttongroup>
      <button *ngFor="let button of iconButtons" kendoButton [svgIcon]="button.icon"
              (click)="button.callback.emit()"></button>
    </kendo-buttongroup>
  </div>
</div>
